Object.defineProperty(exports,"__esModule",{value:true});var _unitlessNumbers=require('../../modules/unitlessNumbers');var _unitlessNumbers2=_interopRequireDefault(_unitlessNumbers);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var normalizeValue=function normalizeValue(property,value){if(!_unitlessNumbers2.default[property]&&typeof value==='number'){value=value+'px';}return value;};exports.default=normalizeValue;


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-native-web/dist/apis/StyleSheet/normalizeValue.js
 ** module id = 341
 ** module chunks = 0
 **/